import { render, staticRenderFns } from "./InventoryCard.vue?vue&type=template&id=097d0b44&"
import script from "./InventoryCard.vue?vue&type=script&lang=js&"
export * from "./InventoryCard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VCardText,VCardTitle,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097d0b44')) {
      api.createRecord('097d0b44', component.options)
    } else {
      api.reload('097d0b44', component.options)
    }
    module.hot.accept("./InventoryCard.vue?vue&type=template&id=097d0b44&", function () {
      api.rerender('097d0b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VaccineViews/VaccineCheckoutPage/components/InventoryCard.vue"
export default component.exports